'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { MdOutlineOpenInNew } from 'react-icons/md';
import ListingAddress from '@/features/listing/components/listing-card/listing-address/listing-address';
import { type ListingCardViewBaseProps } from '@/features/listing/components/listing-card/listing-card-types';
import ListingCarousel from '@/features/listing/components/listing-card/listing-carousel/listing-carousel';
import ListingMessageButton from '@/features/listing/components/listing-card/listing-message/listing-message-button';
import ListingMoveInDate from '@/features/listing/components/listing-card/listing-move-in-date/listing-move-in-date';
import ListingRate from '@/features/listing/components/listing-card/listing-rate/listing-rate';
import ListingUser from '@/features/listing/components/listing-card/listing-user/listing-user';
import ListingVerifications from '@/features/listing/components/listing-card/listing-verifications/listing-verifications';
import { VerificationStatus } from '@/features/user/types/user-id-verification-types';
import { Link } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import Badge from '@/ui/badge/badge';
import styles from './listing-card-view-grid.module.scss';
export default function ListingCardViewGrid(props) {
  const $ = _c(60);
  const {
    isHighPriority,
    isListingLinkDisabled,
    isListingPerson,
    link: t0,
    listing,
    messageSrc,
    showCheckStatus,
    showDescription: t1,
    showEditButton: t2,
    showListingUser: t3,
    showMessageButton: t4,
    showMissingData: t5,
    showMoveInDate: t6,
    showVerifications: t7
  } = props;
  const link = t0 === undefined ? null : t0;
  const showDescription = t1 === undefined ? true : t1;
  const showEditButton = t2 === undefined ? false : t2;
  const showListingUser = t3 === undefined ? true : t3;
  const showMessageButton = t4 === undefined ? true : t4;
  const showMissingData = t5 === undefined ? false : t5;
  const showMoveInDate = t6 === undefined ? true : t6;
  const showVerifications = t7 === undefined ? true : t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      [VerificationStatus.New]: "gray",
      [VerificationStatus.Passed]: "green",
      [VerificationStatus.Pending]: "orange",
      [VerificationStatus.Rejected]: "red",
      [VerificationStatus.Error]: "red"
    };
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const listingStatusToBadgeColor = t8 as const;
  const translatesListingCard = useTranslations("listing.card");
  const translatesVerifications = useTranslations("global.verifications");
  const translatesActions = useTranslations("global.actions");
  let t9;
  if ($[1] !== isHighPriority || $[2] !== listing.id || $[3] !== listing.images || $[4] !== listing.isBookmarked || $[5] !== listing.isNew || $[6] !== listing.listingTypeId || $[7] !== listing.refreshed || $[8] !== listing.title || $[9] !== showEditButton || $[10] !== translatesActions) {
    t9 = () => <>{showEditButton && <div className={styles.listingCardViewGrid_editButton}>{translatesActions("edit")}</div>}<ListingCarousel listingRefreshedDate={listing.refreshed} images={listing.images} imagesAlt={listing.title} isNew={listing.isNew} isBookmarked={listing.isBookmarked} listingId={listing.id} listingTypeId={listing.listingTypeId} isHighPriority={isHighPriority} /></>;
    $[1] = isHighPriority;
    $[2] = listing.id;
    $[3] = listing.images;
    $[4] = listing.isBookmarked;
    $[5] = listing.isNew;
    $[6] = listing.listingTypeId;
    $[7] = listing.refreshed;
    $[8] = listing.title;
    $[9] = showEditButton;
    $[10] = translatesActions;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const renderListingCarousel = t9;
  let t10;
  if ($[12] !== isListingPerson || $[13] !== listing.addressFormatted || $[14] !== listing.addressVerificationStatus || $[15] !== listing.calendar || $[16] !== listing.description || $[17] !== listing.isDataMissing || $[18] !== listing.listingTypeId || $[19] !== listing.rates || $[20] !== listing.title || $[21] !== listing.user || $[22] !== showCheckStatus || $[23] !== showDescription || $[24] !== showMissingData || $[25] !== showMoveInDate || $[26] !== showVerifications || $[27] !== translatesListingCard || $[28] !== translatesVerifications) {
    t10 = () => <>{(showMissingData && listing.isDataMissing || showCheckStatus) && <div className={styles.listingCardViewGrid_badges}>{showMissingData && listing.isDataMissing && <Badge>{translatesListingCard("complete-listing")}</Badge>}{showCheckStatus && <Badge color={listingStatusToBadgeColor[listing.addressVerificationStatus]}>{translatesVerifications(`address-check-${listing.addressVerificationStatus}`)}</Badge>}</div>}<h3 className={styles.listingCardViewGrid_title}>{listing.title}</h3><ListingAddress address={listing.addressFormatted} listingTypeId={listing.listingTypeId} />{showDescription && <div className={styles.listingCardViewGrid_description}><p dangerouslySetInnerHTML={{
          __html: listing.description.replaceAll(/\r\n|\r|\n/g, "")
        }} /><MdOutlineOpenInNew className={styles.listingCardViewGrid_descriptionIcon} /></div>}{showMoveInDate && <ListingMoveInDate moveInDate={listing.calendar.dateIn} isListingPerson={isListingPerson} />}<div className={styles.listingCardViewGrid_rate}><ListingRate rate={listing.rates} /></div>{showVerifications && <ListingVerifications isAddressVerified={listing.addressVerificationStatus} userVerifications={listing.user.verifications} />}</>;
    $[12] = isListingPerson;
    $[13] = listing.addressFormatted;
    $[14] = listing.addressVerificationStatus;
    $[15] = listing.calendar;
    $[16] = listing.description;
    $[17] = listing.isDataMissing;
    $[18] = listing.listingTypeId;
    $[19] = listing.rates;
    $[20] = listing.title;
    $[21] = listing.user;
    $[22] = showCheckStatus;
    $[23] = showDescription;
    $[24] = showMissingData;
    $[25] = showMoveInDate;
    $[26] = showVerifications;
    $[27] = translatesListingCard;
    $[28] = translatesVerifications;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const renderListingInfo = t10;
  const t11 = !isListingPerson && showCheckStatus && styles[`listingCardViewGrid__${listing.addressVerificationStatus}Status`];
  const t12 = isListingPerson && showCheckStatus && styles.listingCardViewGrid__personListing;
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = cx(styles.listingCardViewGrid, t11, t12);
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== isListingLinkDisabled || $[34] !== link || $[35] !== listing.id || $[36] !== listing.title || $[37] !== renderListingCarousel) {
    t14 = isListingLinkDisabled ? <div>{renderListingCarousel()}</div> : <Link href={link ?? `${ROUTER_LINKS.listings}/${String(listing.id)}`} title={listing.title} prefetch={false}>{renderListingCarousel()}</Link>;
    $[33] = isListingLinkDisabled;
    $[34] = link;
    $[35] = listing.id;
    $[36] = listing.title;
    $[37] = renderListingCarousel;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== listing.user || $[40] !== showListingUser) {
    t15 = showListingUser && <Link className={styles.listingCardViewGrid_user} href={`${ROUTER_LINKS.profile}/${String(listing.user.id)}`} prefetch={false}><ListingUser user={listing.user} /></Link>;
    $[39] = listing.user;
    $[40] = showListingUser;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== isListingLinkDisabled || $[43] !== link || $[44] !== listing.id || $[45] !== listing.title || $[46] !== renderListingInfo) {
    t16 = isListingLinkDisabled ? <div className={styles.listingCardViewGrid_info}>{renderListingInfo()}</div> : <Link className={styles.listingCardViewGrid_info} href={link ?? `${ROUTER_LINKS.listings}/${String(listing.id)}`} title={listing.title} prefetch={false}>{renderListingInfo()}</Link>;
    $[42] = isListingLinkDisabled;
    $[43] = link;
    $[44] = listing.id;
    $[45] = listing.title;
    $[46] = renderListingInfo;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== listing || $[49] !== messageSrc || $[50] !== showMessageButton) {
    t17 = showMessageButton && <div className={styles.listingCardViewGrid_message}><ListingMessageButton listing={listing} messageSrc={messageSrc} /></div>;
    $[48] = listing;
    $[49] = messageSrc;
    $[50] = showMessageButton;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== t15 || $[53] !== t16 || $[54] !== t17) {
    t18 = <div className={styles.listingCardViewGrid_body}>{t15}{t16}{t17}</div>;
    $[52] = t15;
    $[53] = t16;
    $[54] = t17;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t13 || $[57] !== t14 || $[58] !== t18) {
    t19 = <article className={t13}>{t14}{t18}</article>;
    $[56] = t13;
    $[57] = t14;
    $[58] = t18;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  return t19;
}